import * as stylex from "@stylexjs/stylex";
import * as scale from "d3-scale";
import { motion } from "framer-motion";
import { Pause30 } from "icons/Pause";
import { Play30 } from "icons/Play";
import * as React from "react";
import { breakpoints, colors } from "../materials/consts.stylex";
import { typography } from "../materials/typography.stylex";
const stylexStyles = {
    root: {
        ksoyAI: "xzt5al7",
        kaIpWk: "x1m3ak92",
        kZKoxP: "x10w6t97",
        k1xSpc: "x78zum5",
        kGNEyG: "x6s0dn4",
        kjj79g: "x1qughib",
        k7Eaqz: "x1u2d2a2 x10qok78",
        kWkggS: "x1kf733v",
        kMzoRj: "xmkeg23",
        ksu8eU: "x1y0btm7",
        kVAM5u: "x1hhxfu6",
        kMwMTN: "x12klvby",
        kpe85a: "xnuq7ks",
        kWEjV4: "x1brutrg",
        $$css: true
    }
};
export function Timeline({ range, onChange, checked = false, interval = 1000 }) {
    const [from, to] = range;
    const steps = to - from + 1;
    const [isChecked, setIsChecked] = React.useState(checked);
    const [selectedTime, setSelectedTime] = React.useState(to);
    const index = React.useRef(0);
    const { timeScale, percentScale } = React.useMemo(()=>{
        const timeScale = scale.scaleLinear().domain([
            0,
            steps - 1
        ]).range([
            from,
            to
        ]);
        const percentScale = scale.scaleLinear().domain([
            from,
            to
        ]).range([
            80,
            0
        ]); // Magic number based on text width for a year, e.g. "2001"
        return {
            timeScale,
            percentScale
        };
    }, [
        steps,
        from,
        to
    ]);
    React.useEffect(()=>{
        let timeoutId;
        const go = (i)=>{
            const next = timeScale(i % steps);
            next && setSelectedTime(Math.round(next));
            timeoutId = setTimeout(()=>go(++index.current), interval);
        };
        isChecked && go(index.current);
        return ()=>clearTimeout(timeoutId);
    }, [
        isChecked,
        steps,
        to,
        timeScale,
        interval
    ]);
    React.useEffect(()=>{
        onChange(selectedTime);
    }, [
        onChange,
        selectedTime
    ]);
    React.useEffect(()=>{
        setIsChecked(checked);
    }, [
        checked
    ]);
    return <div {...stylex.props(typography.table, stylexStyles.root)}>
      <button className="x1td3qas x10w6t97 x6e1os3 xmkeg23 x1y0btm7 x1wzfk3z x16rqkct x1awj2ng x78zum5 x6s0dn4 xl56j7k x1717udv x1y332i5 x1uvtmcs xvrvchz" onClick={()=>setIsChecked(!isChecked)}>
        {isChecked ? <Pause30/> : <Play30/>}
      </button>
      <div className="x1hr2gdg xuxw1ft x1g63ow2">
        <motion.span initial={{
        marginRight: `${percentScale(selectedTime)}%`
    }} animate={{
        marginRight: `${percentScale(selectedTime)}%`
    }}>
          {selectedTime}
        </motion.span>
      </div>
    </div>;
}
